module.exports = __webpack_public_path__ + "img/confirm-material.23c6b05c.svg";